import { fullPageRedirect } from '@hungryroot/environment';
import { Paragraph, Heading, Text, Button } from '@hungryroot/ramen';
import { useReactivateAccount } from '../../hooks/useReactivateAccount';
import styles from './Success.module.css';
import pageStyles from '../page.module.css';

export const reactivateRoute = '/account/reactivated/';

interface Props {
  testid?: string;
}

export function Success(props: Props) {
  const { testid } = props;

  const { mutate: reactivateAccountMutation, isPending } =
    useReactivateAccount();

  return (
    <div data-testid={testid} className={pageStyles.container}>
      <div data-testid={`${testid}-text-section`} className={styles.text}>
        <Heading variant="H1" testid={`${testid}-heading`}>
          Thanks for all your feedback. Your Hungryoot plan has been cancelled.
        </Heading>
      </div>
      <div className={pageStyles.content}>
        <div className={pageStyles['content-inner']}>
          <Paragraph variant="lead">
            We’ll miss you! If you’re ready to come back (or craving some Black
            Bean Brownie Batter), just log back into the site with your current
            info and click through to REACTIVATE.
          </Paragraph>
          <Button
            buttonType="button"
            onClick={() => {
              reactivateAccountMutation(undefined, {
                onSuccess: () => {
                  fullPageRedirect(reactivateRoute);
                },
              });
            }}
            style="default"
            testid={`${testid}-reactivate`}
            size="medium"
            prominence="primary"
            textPrimary="Reactivate"
            className={styles.reactivate}
            loading={isPending}
            width="full-width"
          />
          <Text>
            *Please note that any processed deliveries have not been cancelled
            and can be viewed on your My Hungryroot page. After clicking
            Reactivate, your credit card willl be charged when your upcoming
            delivery processes the Monday or Thursday before shipment, depending
            on your delivery day.
          </Text>
        </div>
      </div>
    </div>
  );
}
